import { useState } from 'react';
import { Checkbox, Form, Modal } from 'antd';
import { BookyInput, InputType } from '../Forms/BookyInput';
import { DeleteOutlined } from '@ant-design/icons';
import { ReplyService } from '../../Services/ReplyService';
import { TextService } from '../../Services/TextService';

export const DeleteReplyIcon = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    // Whether the person gets the message by e-mail. A reply without e-mail (added by an admin) has nobody to
    // send to, unless it is a family member whose mail goes to the primary - the API decides that.
    const [sendEmail, setSendEmail] = useState(true);
    const GetText = TextService.GetText;

    const close = () => {
        form.resetFields();
        setSendEmail(true);
        setOpen(false);
    };

    const onDelete = async (values: any) => {
        await ReplyService.DeleteReply(props.reply.id, sendEmail ? values.message : "", sendEmail);
        close();
        props.onReplyDelete();
    }

    return (
        <>
            <Modal
                open={open}
                title={GetText("DeleteReply_DeleteHeader")}
                okText={GetText("Common_Delete")}
                okButtonProps={{ danger: true }}
                cancelText={GetText("Common_Cancel")}
                onOk={() => {
                    form
                        .validateFields()
                        .then(onDelete)
                        .catch(() => { });
                }}
                onCancel={close}
            >
                <p>{props.reply.customerName}{props.reply.customerEmail ? <i>{" <" + props.reply.customerEmail + ">"}</i> : ""}</p>
                <Checkbox checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)} style={{ marginBottom: "8px" }}>
                    {GetText("DeleteReply_SendEmail")}
                </Checkbox>
                {/* The message is only needed when it is sent. */}
                {sendEmail ?
                    <Form form={form} onFinish={onDelete}>
                        <BookyInput name="message" type={InputType.multiline} requiredMessage={GetText("DeleteReply_MessageRequired")} placeholder={GetText("DeleteReply_MessagePlaceHolder")} />
                    </Form> : ""}
            </Modal >

            <div>
                <DeleteOutlined onClick={() => {
                    setOpen(true);
                }} />
            </div>
        </>
    );
};

export default DeleteReplyIcon;
